import React from 'react';

const HealthCheck: React.FC = () => {
  return <div>Health Check: OK</div>;
};

export default HealthCheck;